(function () {
    /**
     * Smart fields module
     *
     * @type {angular.Module|module}
     */
    var smartFieldsModule = angular.module('harriApp.smartFields');

    /**
     * Searchable items controller
     *
     * @namespace SearchableItems
     * @param $scope
     * @param element
     * @param $timeout
     * @constructor
     * @private
     */
    var SearchableItemsController = function ($scope, element, $timeout) {
        /**
         *
         * @name SearchableItemsController
         */
        var self = this;

        /**
         * This to get the initial height fot the container of this element
         */
        var smartFieldsContainerHeight;

        /**
         * Private items
         */
        var onInit = function () {
            var itemsNumber = 0;

            for (var i in self.items) {
                var items = self.items[i].items;
                itemsNumber += items.length;
            }

            self.isEmpty = !itemsNumber;

            $timeout(function () {
                $(element).find('input').focus();

                /**
                 * Get the height for the container
                 */
                smartFieldsContainerHeight = $(element).find('.smart-fields').outerHeight();
            }, 1);
        };

        /**
         * Scroll event
         *
         * @type {Function}
         */
        var onScrollElementEvent = function () {
            var sections = $(element).find('.items-chooser').find('.section-title:visible');
            var header = $(element).find('.searchable-header');
            var lastHiddenElement;

            for (var i = 0; i < sections.length; i++) {
                var section = $(sections[i]);
                var parentTop = section.parents('.section').position().top;

                if (( parentTop - header.outerHeight() - 22 ) < 0) {
                    lastHiddenElement = section;
                }
            }

            var fixedHeader = $(element).find('.section-title-fixed');
            fixedHeader.empty();

            if (lastHiddenElement) {
                var fixedHeaderHtml = '<div class="section-title">' + lastHiddenElement.html() + '</div>';

                fixedHeader.html(fixedHeaderHtml);
            }
        };

        /**
         * Handle when user click on header to show the cursor
         */
        var onHeaderClicked = function () {
            $timeout(function () {
                $(element).find('.searchable-header').find('input').focus();
            }, 1);
        };

        /**
         * Handle when user clear all items on input
         *
         * @param event
         */
        var onHeaderInputChanged = function (event) {
            var input  = $(this);

            if ((event.which === 8 || event.which === 46) && input.val() === '') {
                $timeout(function () {

                    if (self.selectedItems && self.selectedItems.length) {
                        self.remove(self.selectedItems[self.selectedItems.length - 1]);
                    }

                    input.focus();
                }, 1);
            }
        };

        /**
         * End private items
         */

        /**
         * Public items
         */

        /**
         * On init for this component
         */
        self.$onInit = function () {
            var changed = [];

            if (typeof (self.data) !== 'undefined') {
                self.items = $.extend(true, {}, self.data);
                changed.push(true);
            }

            if (typeof (self.selectedModel) !== 'undefined') {
                self.selectedItems = $.extend(true, [], self.selectedModel);
                changed.push(true);
            }

            if (changed.length === 1) {
                onInit();
            }
        };

        /**
         * Watch changes for this component
         *
         * @param changes
         */
        self.$onChanges = function (changes) {
            var changed = [];

            if (
                changes.data &&
                !changes.data.isFirstChange() &&
                JSON.stringify(changes.data.currentValue) !== JSON.stringify(self.items)
            ) {
                self.items = $.extend(true, {}, changes.data.currentValue);
                changed.push(true);
            }

            if (
                changes.selectedModel &&
                !changes.selectedModel.isFirstChange() &&
                JSON.stringify(changes.selectedModel.currentValue) !== JSON.stringify(self.selectedItems)
            ) {
                self.selectedItems = $.extend(true, [], changes.selectedModel.currentValue);
                changed.push(true);
            }

            if (changed.length) {
                onInit();
            }
        };

        /**
         * Filter list on search input
         *
         * @name SearchableItemsController#searchItems
         */
        self.searchItems = function () {
            self.items = $.extend(true, {}, self.data);

            var filteredText = self.searchText;

            /**
             * Start search for elements when user start writing
             */
            if (filteredText) {
                /**
                 * Create new filtered sections because this component divided as sections
                 */
                var filteredSections = {};

                /**
                 * Using the compare function from outside the component
                 * start filters users if its true add is to new filtered section
                 */
                for (var i in self.items) {
                    var section = self.items[i];

                    /**
                     * Sometimes data input for this component is just a header that grouped some items
                     * for example:
                     * {DIRECT_MESSAGES: {is_parent: true, title: 'direct messages', children: ['GROUP', 'USERS']}, GROUP: {hide_title: true, items: []}}
                     * as here when the data rendered it render the direct messages title but the children items
                     */
                    if (!section.is_parent) {

                        for (var j in section.items) {
                            var item = section.items[j];

                            /**
                             * No need to show already selected items
                             */
                            var isItemFoundOnSelectedItems = _.findIndex(self.selectedItems, {id: item.id}) > -1;

                            /**
                             * This because we take a copy from ordinal data and selected items shows as not selected
                             * @type {boolean}
                             */
                            item.selected = isItemFoundOnSelectedItems;

                            /**
                             * This is a compare function for component to work
                             */
                            if (self.compareFunction({value: filteredText, item: item}) && !isItemFoundOnSelectedItems) {

                                /**
                                 * Create new section if its not added to new filtered sections and make sure its not chosen before
                                 */
                                if (!filteredSections[i]) {
                                    var newSection = {};
                                    newSection.order = section.order;
                                    newSection.title = section.title;
                                    newSection.hide_title = section.hide_title;
                                    newSection.limit_to = section.limit_to;
                                    newSection.items = [];

                                    filteredSections[i] = newSection;
                                }

                                filteredSections[i].items.push(item);
                            }
                        }
                    }
                }

                /**
                 * Just to show the parent title if its children has items after filters
                 */
                for (var i in self.items) {
                    var section = self.items[i];

                    if (section.is_parent) {

                        for (var j in section.children) {
                            var child = section.children[j];

                            if (filteredSections[child]) {
                                filteredSections[i] = section;
                                break;
                            }
                        }
                    }
                }

                self.items = filteredSections;

                $(element)
                    .find('.searchable-items')
                    .find('.items-chooser')
                    .scrollTop(0);
            } else {
                for (var i in self.items) {
                    var section = self.items[i];

                    for (var j in section.items) {
                        var item = section.items[j];

                        /**
                         * No need to show already selected items
                         */
                        var isItemFoundOnSelectedItems = _.findIndex(self.selectedItems, {id: item.id}) > -1;

                        /**
                         * This because we take a copy from ordinal data and selected items shows as not selected
                         * @type {boolean}
                         */
                        item.selected = isItemFoundOnSelectedItems;
                    }
                }
            }

            self.isEmpty = Object.keys(self.items).length === 0;
        };

        /**
         * Select item from list
         * @name SearchableItemsController#select
         *
         * @param item
         */
        self.select = function (item) {
            /**
             * Empty the search value
             *
             * @type {string}
             */
            self.searchText = '';

            /**
             * Push new item to selected items
             * @type {Array}
             */
            self.selectedItems = self.selectedItems || [];
            self.selectedItems.push(item);

            /**
             * Set item as selected
             * @type {boolean}
             */
            item.selected = true;

            /**
             * This to check if all items is selected
             * @type {number}
             */
            var itemsNumber = 0;

            for (var i in self.items) {
                var items = self.items[i].items;
                itemsNumber += items.length;
            }

            /**
             * Show empty section when there is any items exist
             * @type {boolean}
             */
            self.isEmpty = !itemsNumber;

            /**
             * Trigger on select event
             */
            self.onSelect({items: self.selectedItems});

            /**
             * Reset search filter if there is already saved data
             */
            self.searchItems();

            /**
             * change scroll height after choose new elements
             */
            $timeout(function () {
                var header = $(element).find('.searchable-header');

                if (header.outerHeight() < (smartFieldsContainerHeight - 200)) {
                    $(element)
                        .find('.searchable-items')
                        .find('.items-chooser')
                        .css('overflow-y', 'auto')
                        .css('height', 'calc(100vh - ' + (header.outerHeight() + 173 + (self.additionalScrollCalcHeight || 0)) + 'px)');
                } else {
                    $(element)
                        .find('.searchable-items')
                        .find('.items-chooser')
                        .css('overflow-y', 'hidden')
                        .css('height', 'initial');
                }

                onScrollElementEvent();

                onHeaderClicked();
            }, 50);
        };

        /**
         * Remove item from list
         * @name SearchableItemsController#remove
         *
         * @param item
         */
        self.remove = function (item) {
            /**
             * Get item by its reference and return its index to remove it from selected items
             * @type {*|number}
             */
            var indexOfItem = self.selectedItems.indexOf(item);
            self.selectedItems.splice(indexOfItem, 1);
            item.selected = false;

            var itemsNumber = 0;

            /**
             * Loop through sections and get number of items on each section
             */
            for (var i in self.items) {
                var items = self.items[i].items;
                itemsNumber += items.length;
            }

            /**
             * Show empty section if there is no items exist
             * @type {boolean}
             */
            self.isEmpty = !itemsNumber;

            /**
             * Reset search filter if there is already saved data
             */
            self.searchItems();

            $timeout(function () {
                var header = $(element).find('.searchable-header');

                if (
                    header.outerHeight() < (smartFieldsContainerHeight - 200)
                ) {
                    $(element)
                        .find('.searchable-items')
                        .find('.items-chooser')
                        .css('overflow-y', 'auto')
                        .css('height', 'calc(100vh - ' + (header.outerHeight() + 173 + (self.additionalScrollCalcHeight || 0)) + 'px)');
                } else {
                    $(element)
                        .find('.searchable-items')
                        .find('.items-chooser')
                        .css('overflow-y', 'hidden')
                        .css('height', 'initial');
                }

                onScrollElementEvent();
                onHeaderClicked();
            }, 50);
        };

        /**
         * destroy controller
         */
        self.$onDestroy = function () {
            $(element)
                .find('.searchable-items')
                .find('.items-chooser')
                .off('scroll', onScrollElementEvent);

            $(element)
                .find('.searchable-header')
                .off('click', onHeaderClicked);

            $(element)
                .find('.searchable-header')
                .find('input')
                .on('keydown', onHeaderInputChanged);
        };

        /**
         * Attach scroll events
         */
        self.$postLink = function () {

            $(element)
                .find('.searchable-items')
                .find('.items-chooser')
                .on('scroll', onScrollElementEvent);

            $(element)
                .find('.searchable-header')
                .off('click')
                .on('click', onHeaderClicked);

            $(element)
                .find('.searchable-header')
                .find('input')
                .off('keydown')
                .on('keydown', onHeaderInputChanged);
        };

        /**
         * End public items
         */
    };

    /**
     * Searchable items component
     */
    var SearchableItemsComponent = {
        bindings: {
            inputTitle: '@',
            data: '<',
            placeholder: '@',
            emptyText: '@',
            onSelect: '&',
            compareFunction: '&',
            saveAction: '&',
            actionTitle: '@',
            additionalScrollCalcHeight: '<',
            showAction: '<',
            selectedModel: '<'
        },
        templateUrl: '../modules/smart-fields/components/searchable-items/searchable-items.html',
        controller: ['$scope', '$element', '$timeout', SearchableItemsController],
        controllerAs: 'SearchableItems'
    };

    /**
     * Create search items component
     */
    smartFieldsModule.component('searchableItems', SearchableItemsComponent);
})();